import React from 'react'
import { Grid } from '@material-ui/core'
import DataPanel from 'components/theme/DataPanel'

export default () => (
  <Grid container spacing={24}>
    <Grid item xs={4}>
      <DataPanel color="green" />
    </Grid>
    <Grid item xs={4}>
      <DataPanel color="orange" />
    </Grid>
    <Grid item xs={4}>
      <DataPanel color="pink" />
    </Grid>
  </Grid>
)
